export default __webpack_public_path__ + "static/media/Q3_4_resized.91858d7e.jpg";